import * as React from 'react';
import { DragDropContext, Draggable, Droppable, DropResult, ResponderProvided } from 'react-beautiful-dnd';

// import ui
import { DefaultButton, Panel, PanelType, PrimaryButton, Stack, Text } from '@fluentui/react';

// import services
import ProductService from '../../../../../services/products';

// import interfaces
import { IProductResourceShort } from '../../../../../props/products';

// import component

// import styles
import styles from './styles.module.scss';
import GeneralConfig from '../../../../../config';
import LoadingComponent from '../../../../../components/loading';

interface ISortProductPanelProps {
  closePanel: (refresh?: boolean) => void;
}

interface IUpdateProduct extends IProductResourceShort {
  orderNumber: string;
}

interface ISortProductPanelState {
  products: IProductResourceShort[];
  updateProducts: IProductResourceShort[];
  loaded: boolean;
  submiting: boolean;
}

export default class SortProductPanel extends React.Component<
  ISortProductPanelProps,
  ISortProductPanelState
> {
  constructor(props: ISortProductPanelProps) {
    super(props);

    this.state = {
      products: [],
      loaded: false,
      submiting: false,
      updateProducts: [],
    };
  }

  componentDidMount() {
    this.getProducts();
  }

  private getProducts = async () => {
    this.setState({ loaded: false });
    try {
      const products = await ProductService.retrieve();
      this.setState({ products, loaded: true });
    } catch (error) {}
  };

  public render() {
    const { products, loaded } = this.state;
    return (
      <Panel
        headerText='Ubah Urutan Produk'
        type={PanelType.medium}
        isOpen
        onDismiss={() => this.props.closePanel()}
        onRenderFooterContent={this.onRenderFooter}
        isFooterAtBottom={true}
        closeButtonAriaLabel='Close'
      >
        {loaded && (
          <DragDropContext onDragEnd={this.onDragEnd}>
            <Droppable droppableId='droppable'>
              {(provided, snapshot) => (
                <section {...provided.droppableProps} ref={provided.innerRef}>
                  {products.map((f, index) => (
                    <Draggable key={f.id} draggableId={f.id} index={index}>
                      {(provided, snapshot) => (
                        <section
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          style={{
                            ...provided.draggableProps.style,
                            position: 'static',
                            background: '#ffffff',
                          }}
                          className={styles.columnItem}
                        >
                          <Stack
                            key={f.id}
                            className={styles.item}
                            horizontal
                            verticalAlign='center'
                            tokens={{ childrenGap: 10 }}
                          >
                            {f.images.map((i) => (
                              <img
                                key={i.id}
                                src={GeneralConfig.assetsHostname + '/' + i.url}
                                className={styles.image}
                              />
                            ))}
                            <Text>{f.name}</Text>
                          </Stack>
                        </section>
                      )}
                    </Draggable>
                  ))}
                </section>
              )}
            </Droppable>
          </DragDropContext>
        )}
      </Panel>
    );
  }

  private onDragEnd = (result: DropResult, provided: ResponderProvided) => {
    const { products: items } = this.state;
    let newNumber: number = 0;

    const lastIndex = items.length - 1;
    if (result.destination) {
      const to = result.destination.index;
      const from = result.source.index;

      if (Number(items[from].orderNumber) > Number(items[to].orderNumber)) {
        if (to - 1 !== lastIndex) {
          if (items[to - 1]) {
            newNumber = (Number(items[to].orderNumber) + Number(items[to - 1].orderNumber)) / 2;
          } else {
            newNumber = Number(items[to].orderNumber) / 2;
          }
        } else {
          newNumber = Number(items[to].orderNumber) - 1;
        }
      } else {
        if (items[to + 1]) {
          newNumber = (Number(items[to].orderNumber) + Number(items[to + 1].orderNumber)) / 2;
        } else {
          newNumber = Number(items[to].orderNumber) + 1;
        }
      }

      Number.isNaN(newNumber) && (newNumber = Math.floor(Math.random() * 10) + 1);

      this.updateColumns(items, from, to, newNumber);

      this.updateOrderNumber(newNumber, items[from]);
    }
  };

  private updateOrderNumber = async (orderNumber: number, product: IProductResourceShort) => {
    const { updateProducts } = this.state;
    const findToppings = updateProducts.findIndex((f) => f.id === product.id);
    if (updateProducts[findToppings]) {
      updateProducts[findToppings].orderNumber = String(orderNumber);
    } else {
      updateProducts.push(product);
    }

    this.setState({ updateProducts });
  };

  private updateColumns = (
    products: IProductResourceShort[],
    from: number,
    to: number,
    newOrderNumber: number
  ) => {
    products[from].orderNumber = String(newOrderNumber);
    this.setState({ products: this._reorder(products, from, to) });
  };

  private _reorder = (list: IProductResourceShort[], startIndex: number, endIndex: number) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  private onRenderFooter = () => {
    if (!this.state.submiting) {
      return (
        <Stack horizontal tokens={{ childrenGap: 10 }}>
          {this.state.updateProducts.length !== 0 && <PrimaryButton text='Save' onClick={this.onSubmit} />}
          <DefaultButton text='Cancel' onClick={() => this.props.closePanel()} />
        </Stack>
      );
    } else {
      return <LoadingComponent label={'Mengubah Urutan Product'} />;
    }
  };

  private onSubmit = async () => {
    const { updateProducts } = this.state;

    const fd = new FormData();
    updateProducts.forEach((u) => fd.append('products[]', JSON.stringify(u)));
    this.setState({ submiting: true });
    try {
      await ProductService.reorder(fd);
      this.props.closePanel(true);
      this.setState({ submiting: false });
    } catch (error) {
      this.setState({ submiting: false });
    }
  };
}
